const EventCopyControllers = require('./copy');
const EventBulkControllers = require('./bulk');

angular.module('backstage.controllers.events', [EventCopyControllers, EventBulkControllers])
    .controller('QuickAddEventTeamMemberCtrl', require('./QuickAddEventTeamMemberCtrl'));

